import { render, staticRenderFns } from "./register-personal.vue?vue&type=template&id=3d9b82ca&scoped=true&"
import script from "./register-personal.vue?vue&type=script&lang=js&"
export * from "./register-personal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=3d9b82ca&scoped=true&lang=css&"
import style1 from "@/assets/sass/home.css?vue&type=style&index=1&id=3d9b82ca&scoped=true&lang=css&"
import style2 from "./register.scss?vue&type=style&index=2&id=3d9b82ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b82ca",
  null
  
)

export default component.exports